export const passwordRegex = /^(?=.*?[a-z])(?=.*?[0-9])(?=.*?[A-Z]).{8,}$/;

export const bigLetterRegex = /[A-Z]/;

export const smallLetterRegex = /[a-z]/;

export const numberRegex = /[0-9]/;

export const eightOrMoreCharactersRegex = /^(?=.*).{8,}$/;
